import { render, staticRenderFns } from "./DocYzwlInfo.vue?vue&type=template&id=172bc5da&scoped=true"
import script from "./DocYzwlInfo.vue?vue&type=script&lang=js"
export * from "./DocYzwlInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172bc5da",
  null
  
)

export default component.exports